module.exports = __webpack_public_path__ + "img/3_1.779f6ef1.jpg";